import { Flex, Button, Icon } from '@chakra-ui/react';
import colors from 'src/theme/colors';
import Icons from '../Icons';

export default function MobileTopNav() {
  return (
    <Flex
      as="section"
      h="100%"
      w="100vw"
      bg="podcastPurple"
      px="20px"
      justifyContent="space-between"
      alignItems="center"
    >
      <Icons.AlituLogoWithText />
      <Menu />
    </Flex>
  );
}

function Menu() {
  return (
    <Button visual="flat" as="nav" bg="podcastPurple" textTransform="capitalize">
      <MenuIcon />
      menu
    </Button>
  );
}

function MenuIcon() {
  return (
    <Icon width="18px" height="12px">
      <svg viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17 1H1M17 6H1M17 11H1"
          stroke={colors.white}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
}
